











































































































import { Component, Vue } from 'vue-property-decorator';
import { UserDetail } from '@/models';

@Component({})
export default class UserDetailPage extends Vue {
  profile = this.$store.state.profile;
  form: UserDetail = new UserDetail();

  created() {
    this.$store.dispatch('profile/getProfile').then(profile => {
      this.form.firstName.value = profile.firstName;
      this.form.lastName.value = profile.lastName;
    });
  }

  resetCustomErrors(): void {
    this.form.oldPassword.errorMessage = '';
    this.form.newPassword.errorMessage = '';
    this.form.confirmPassword.errorMessage = '';
  }

  resetUserCustomErrors(): void {
    this.form.firstName.errorMessage = '';
    this.form.lastName.errorMessage = '';
    this.form.preferredCultureCode.errorMessage = '';
  }

  submit(): void {
    (this.$refs.form as any).validate();
    this.form.customValidate();

    if (this.form.valid) {
      const user = {
        firstName: this.profile.profileState.firstName,
        lastName: this.profile.profileState.lastName,

        PasswordChange: {
          OldPassword: this.form.oldPassword.value,
          NewPassword: this.form.newPassword.value
        }
      };
      this.form;
      this.$store.dispatch('profile/editProfile', { user }).then(() => {
        (this.$refs.form as any).reset();
      });
    }
  }

  submitUpdateUser(): void {
    (this.$refs.editUserForm as any).validate();
    if (this.form.userEditValid) {
      const user = {
        firstName: this.form.firstName.value,
        lastName: this.form.lastName.value
      };
      this.form;
      this.$store.dispatch('profile/editProfile', { user }).then(() => {
        (this.$refs.form as any).reset();
      });
    }
  }
}
